import { render, staticRenderFns } from "./LowAgeConfirmModal.vue?vue&type=template&id=348b957b&scoped=true"
import script from "./LowAgeConfirmModal.vue?vue&type=script&lang=js"
export * from "./LowAgeConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./LowAgeConfirmModal.vue?vue&type=style&index=0&id=348b957b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b957b",
  null
  
)

export default component.exports